import { ReactNode } from "react";

import { TableFloatingSelectionBar } from "@/components/molecules/SelectableListSelectionBar";
import type {
  SelectionBarButton,
  TableDialogSelectionActionsProps,
} from "@/components/molecules/SelectableListSelectionBar";
import {
  useTableStore,
  useTableStoreApi,
} from "@/components/organisms/Table/Table.store";

export type { TableDialogSelectionActionsProps };

export function TableDialog({
  nameAsSingular,
  totalCount,
  getSummary = () => null,
  buttons = [],
  extraActions,
}: {
  nameAsSingular: string;
  /** Every row the list matches, for a button that can act on them all. */
  totalCount?: number;
  getSummary?: (checkedRows: any) => string;
  buttons?: SelectionBarButton[];
  extraActions?: (props: TableDialogSelectionActionsProps) => ReactNode;
}) {
  const isAllRowsChecked = useTableStore((state) => state.isAllRowsChecked);
  const checkedRows = useTableStore((state) => state.checkedRows);
  const numCheckedRows = useTableStore(
    (state) => Object.values(state.checkedRows).filter((row) => row).length,
  );
  const summary = numCheckedRows > 0 ? getSummary(checkedRows) : null;
  const storeApi = useTableStoreApi();
  const clearAllCheckedRows = () =>
    storeApi.setState({
      checkedRows: Object.keys(checkedRows).reduce(
        (acc, key) => ({ ...acc, [key]: false }),
        {},
      ),
      isAllRowsChecked: false,
    });

  const checkedRowIds = Object.keys(checkedRows).filter(
    (key) => checkedRows[key],
  );

  return (
    <TableFloatingSelectionBar
      visible={numCheckedRows > 0}
      nameAsSingular={nameAsSingular}
      numCheckedRows={numCheckedRows}
      allRowsChecked={isAllRowsChecked}
      totalCount={totalCount}
      summary={summary}
      onClear={clearAllCheckedRows}
      checkedRowIds={checkedRowIds}
      buttons={buttons}
      extraActions={extraActions}
    />
  );
}
